import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import mobile_login from '../views/mobile/mobile_login.vue'
import register from '../views/register.vue'
import mobile_register from '../views/mobile/register.vue'
import MobileHome from '../views/mobile/home.vue'
Vue.use(VueRouter)
// 判断是不是移动端
let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
// isMobile?MobileHome:Login
const routes = [
  {
    path: '/',
    name: '首页',
    component: MobileHome
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'register',
    component: register
  },
  {
    path: '/mobile_login',
    name: 'mobile_login',
    component: mobile_login
  },
  {
    path: '/mobile_register',
    name: 'mobile_register',
    component: mobile_register
  },
  {
    path: '/mobile_home',
    name: 'MobileHome',
    component: MobileHome
  },
  {
    path: '/BaziAnalysis',
    name: 'BaziAnalysis',
    component: () => import('../views/mobile/BaziAnalysis.vue')
  },
  // {
  //   path: '/feedback',
  //   name: 'Feedback',
  //   component: () => import('../views/mobile/Feedback.vue')
  // },
  // {
  //   path: '/user-profile',
  //   name: 'UserProfile',
  //   component: () => import('../views/mobile/UserProfile.vue')
  // },
  {
    path: '/edit-birth-info',
    name: 'EditBirthInfo',
    component: () => import('../views/mobile/EditBirthInfo.vue')
  },
  {
    path: '/ai-analysis',
    name: 'AiAnalysis',
    component: () => import('../views/mobile/AiAnalysis.vue')
  },
  {
    path: '/liuyao-analysis',
    name: 'LiuyaoAnalysis',
    component: () => import('../views/mobile/LiuyaoAnalysis.vue'),
    props: route => ({ type: route.query.type })
  },
  {
    path: '/sixYao_ai',
    name: 'sixYao_ai',
    component: () => import('../views/mobile/sixYao_ai.vue'),
    props: route => ({ type: route.query.type })
  },
  {
    path: '/analysis-records',
    name: 'AnalysisRecords',
    component: () => import('../views/mobile/AnalysisRecords.vue'),
    props: route => ({ type: route.query.type })
  },
  {
    path: '/Subscription',
    name: 'Subscription',
    component: () => import('../views/mobile/Subscription.vue'),
    props: route => ({ type: route.query.type })
  },
  {
    path: '/Reanalysis',
    name: 'Reanalysis',
    component: () => import('../views/mobile/Reanalysis.vue')
  },
  
  {
    path: '/success',
    name: 'success',
    component: () => import('../views/mobile/success.vue')
  },
  {
    path: '/fail',
    name: 'fail',
    component: () => import('../views/mobile/fail.vue')
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('../views/index.vue')
  },
  {
    path: '/invite-rewards',
    name: 'InviteRewards',
    component: () => import('../views/mobile/InviteRewards.vue')
  },
  {
    path: '/duanfa-analysis',
    name: 'duanfa',
    component: () => import('../views/mobile/duanfa.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router